module.exports = __webpack_public_path__ + "static/media/image-friday.d7ca865f.jpg";